export default "__VITE_ASSET__CoZyPW_K__"